export const getLastSegment = (pathname) => {
  if (pathname) {
    let slashIndex = pathname.lastIndexOf("/") + 1;
    let urlLastSegment = pathname.substring(slashIndex, pathname.length);
    return urlLastSegment;
  }
};

export const scroll = (id, offset = -200) => {
  console.log(offset);
  const element = document.getElementById(id);
  if (element && window.locomotiveScroll) {
    // Use Locomotive Scroll's scrollTo method
    window.locomotiveScroll.scrollTo(element, {
      duration: 500,
      easing: [0.25, 0.0, 0.35, 1.0],
      offset: offset,
    });
  } else {
    // Fallback to native scrollIntoView
    element?.scrollIntoView({ behavior: "smooth", block: "center" });
  }
};
export const getFirstError = (errors, suffix = "_error") => {
  console.log(`${Object.keys(errors)[0]}${suffix}`);

  return `${Object.keys(errors)[0]}${suffix}`;
};
